import environment from 'kareo-environment-config';

/* global process */

// controlled by build to test phasing out all angular
const isAngularEnabled = process.env.ANGULAR_ENABLED !== undefined ?
  Boolean(process.env.ANGULAR_ENABLED) :
  true;

const analytics = {
  devint: 'jpnlxpeku3',
  test: '1tfciwy3w4',
  stage: '1tfciwy3w4',
  prod: '6b3ww5fyg8',
  prodlas: '6b3ww5fyg8'
};

const intercom = {
  devint: 'lgs0026e',
  test: 'lgs0026e',
  stage: 'lgs0026e',
  prod: 'k2xy5s07',
  prodlas: 'k2xy5s07'
};

const FULLSTORY_ENVIRONMENT_ORGID = {
  devint: '13C9V0',
  test: '13C9V0',
  stage: '13C9V0',
  prod: '13C9V0',
  prodlas: '13C9V0'
};

const WEB_TO_CASE_BASE_ACCOUNT = {
  accountName: "SFord Test Practice",
  externalAccountId: '96224',
  originSiteName: 'Kareo',
  webToCaseURL: 'https://patientpop--zoidberg.sandbox.my.salesforce-sites.com/webToCase',
  scriptSrc: 'https://patientpop--zoidberg.sandbox.my.salesforce-sites.com/webToCase/lightning/lightning.out.js',
};

const WEB_TO_CASE_ACCOUNT = {
  devint: WEB_TO_CASE_BASE_ACCOUNT,
  test: WEB_TO_CASE_BASE_ACCOUNT,
  stage: WEB_TO_CASE_BASE_ACCOUNT,
  prod: WEB_TO_CASE_BASE_ACCOUNT,
  prodlas: WEB_TO_CASE_BASE_ACCOUNT,
};

const INVOICE_HISTORY_BASE = {
  externalAccountId: '122',
  originSiteName: 'kareo'
};

const WOOTRIC_PRODUCTION_ACCOUNT = {
  accountToken: 'NPS-29816f1b',
  noSurveyedCookie: true,
  product: 'Kareo',
  untrackedPaths: [
    /\/facesheet-ui\/#\/chart-navbar\/(.*)/i
  ]
};

const WOOTRIC_SANDBOX_BASE_ACCOUNT = Object.assign({}, WOOTRIC_PRODUCTION_ACCOUNT, {
  accountToken: 'NPS-0f9692fe'
});

const WOOTRIC_ACCOUNT = { 
  devint: WOOTRIC_SANDBOX_BASE_ACCOUNT,
  test: WOOTRIC_SANDBOX_BASE_ACCOUNT,
  stage: WOOTRIC_SANDBOX_BASE_ACCOUNT,
  prod: WOOTRIC_PRODUCTION_ACCOUNT,
  prodlas: WOOTRIC_PRODUCTION_ACCOUNT,
};

const config = {
  analytics: analytics[environment],
  intercom: intercom[environment],
  webToCase: WEB_TO_CASE_ACCOUNT[environment],
  invoiceHistory: INVOICE_HISTORY_BASE,
  fullstoryConfig: {
    enabled: true,
    orgId: FULLSTORY_ENVIRONMENT_ORGID[environment],
    untrackedPaths: [
      /^\/patient-engagement-ui\/#\/(--blocked--|confirmation|finish|patient-message|survey|unsubscribe)/i,
      /^\/patient-engagement-ui\/#--blocked--/i,
      /^\/patient-intake-ui\/#\//i,
      /^\/v2\/#\/mfa(.*)/i,
      /^\/login-ui\/*/i,
    ]
  },
  environment,
  isAngularEnabled,
  wootric: WOOTRIC_ACCOUNT[environment]
};

window.kareoEnvironment = environment;


export default config;

if (isAngularEnabled) {
  angular
    .module('kareo.ui.shared.modules.analytics.environment', [])
    .constant('ANALYTICS_KEY', config.analytics);

  angular.module('kareo.environment.config', [])
    .constant('ENVIRONMENT_NAME', config.environment);

}
